// extracted by mini-css-extract-plugin
export default {"card":"styles_card__aTULJ","heading":"styles_heading__JLNKh","para":"styles_para__vE9Yc","iconWrapper":"styles_iconWrapper__tmJ5c"};